import Game from './game.jsx';

$(document).ready(function(){
  var game = Game.instance;
});



// WEBPACK FOOTER //
// ./js/main.js